import { ValidPropText, validPropTextVM } from '../../../core/components/validation/ValidInputText';
import {
    ValidPropDroplistText,
    validPropDroplistTextVM,
} from '../../../core/components/validation/ValidInputDroplistText';
import { EditStateGroup, AdminGroupsModel, GroupsCreatePageState } from './groups_create_types';
import { validPropRadioTextVM } from '../../../core/components/validation/ValidInputRadioText';
import { validPropRadioBool } from '../../../core/components/validation/ValidInputRadioBool';
import validSvc from '../../../core/validSvc';
import { ValidOption } from '../../../core/components/validation/types';
import { ngContext } from '../../../core/services/ng.delegate';
import utilSvc from '../../../core/utilSvc';

export enum GroupType {
    IDN = 'IDN',
    PHARMACY = 'PHARMACY',
    CE = 'CE',
    MAPPING = 'MAPPING',
}

const contractTypeOptions = [
    { lbl: 'Total generics', val: 'TOTAL' },
    { lbl: 'Total spend by NDC list', val: 'LIST' },
];

const typeOptions = [
    { lbl: 'Facility', val: 'CE' },
    { lbl: 'Pharmacy', val: 'PHARMACY' },
    { lbl: 'Mapping', val: 'MAPPING' },
    { lbl: 'IDN', val: 'IDN' },
];

const statusOptions = [
    { lbl: 'Active', val: 'ACTIVE' },
    { lbl: 'Inactive', val: 'INACTIVE' },
];
// PAGE
export function pageStateVM(): GroupsCreatePageState {
    return {
        init: true,
        title: '',
        canEdit: false,
        mode: '',
        id: '',
    };
}

// EDIT FORM
export function editStateVM(): EditStateGroup {
    return {
        waiting: false,
        members: [],
        memberAddDropList: createMemberAddDroplist(),
        vmaxPopup: false,
        vmaxVendors: [],
    };
}

export function modelVM(data?): AdminGroupsModel {
    data = data || {};

    return {
        Id: !!data.Id ? data.Id : '',
        Name: validPropTextVM('Name', 'Name', data.Name, ''),
        Type: validPropDroplistTextVM('Type', 'Type', data.Type, 'CE', typeOptions),
        ObjectState: validPropRadioTextVM('ObjectState', 'Status', data.ObjectState, 'ACTIVE', statusOptions),
        ContractFulfillment: validPropRadioBool('ContractFulfillment', 'Enabled', !!data.ContractFulfillment, false),
        ContractType: validPropRadioTextVM(
            'ContractType',
            'Contract Type',
            data.ContractType,
            'TOTAL',
            contractTypeOptions,
        ),
        Threshold: Array.isArray(data.Threshold) ? data.Threshold : [],
    };
}

export function membersVM(data?: Record<string, any>): string[] {
    const _data = data || {};
    const result = Array.isArray(_data?.Entities) ? _data.Entities : [];
    result.sort();

    return result.filter(mem => {
        return validSvc.isText(mem);
    });
}

export function createMemberAddDroplist(memType?: string, existing?: string[]): ValidPropDroplistText {
    // build add member droplist, remove existing members as options
    let options: ValidOption[] = [];

    // get options
    if (memType) {
        const ctx = ngContext();
        let affs = ctx.User && Array.isArray(ctx.User?.AffList) ? ctx.User.AffList : [];
        affs = utilSvc.aff.findStatus(affs);

        if (memType === GroupType.CE || memType === GroupType.IDN) {
            options.push({ val: '', lbl: 'Choose a Facility' });
        } else {
            options.push({ val: '', lbl: 'Choose a Pharmacy' });
        }

        switch (memType) {
            case GroupType.CE:
            case GroupType.IDN:
                const ceList = utilSvc.aff.ceList(affs);
                ceList.forEach(ceid => {
                    options.push({ lbl: ceid, val: ceid });
                });
                break;

            case GroupType.PHARMACY:
            case GroupType.MAPPING:
                affs =
                    memType == GroupType.PHARMACY
                        ? utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL'])
                        : utilSvc.aff.findStatus(affs, ['ONBOARDING', 'ACTIVE']);

                const rxDroplist = utilSvc.aff.rxDroplist(affs, undefined, false); // don't use NONE
                rxDroplist.forEach(rx => {
                    options.push({ lbl: rx.label, val: rx.value });
                });
                break;

            default:
                throw new Error('groupEditStore.createMemberAddDroplist, unknown type: ' + memType);
        }
    }

    // filter out existing
    if (options.length > 0 && existing && existing.length > 0) {
        options = options.filter(opt => existing.indexOf(`${opt.val}`) < 0);
    }

    return validPropDroplistTextVM('MemAddId', undefined, undefined, undefined, options);
}

type VmaxVendor = {
    Type: string;
    Name: string;
};

export function vmaxVendorsVM(items?: object[]): ValidPropText[] {
    const parse: string[] = [],
        venList: VmaxVendor[] = Array.isArray(items) ? (items as VmaxVendor[]) : [];
    venList.forEach(ven => {
        if (ven.Type == 'WHOLESALER') {
            parse.push(ven.Name);
        }
    });
    parse.sort();

    const result: ValidPropText[] = [];
    parse.forEach(p => result.push({ lbl: p, val: p, key: p, err: '' }));
    return result;
}
